/**
* Data model that represents an appointment (FlexAppointment)
*
* @class AvailabilityModel
* @param {JSON} data
*/
var AvailabilityModel = function (data) {
  var self;	// Convenience reference so the context of 'this' becomes clearer

  // Predicate this data model on the AbstractDataModel.
  // This establishes core functionality required of DataModels,
  // which can be overwritten by methods below.
  // Specifically, conversion of XML data to JSON
  AbstractDataModel.apply(this, arguments);

  self = this;

  // Observable variables represented by this data model
  self.daysOfWeek = null;
  self.deleted = false;
  self.duration = ko.observable(null);
  self.end = null;
  self.endHour = ko.observable(null);
  self.endMinute = ko.observable(null);
  self.id = null;
  self.recurrence = ko.observableArray([]);
  self.recurrenceStart = null;
  self.recurrenceEnd = null;
  self.recurrenceInterval = ko.observable(null);
  self.startHour = ko.observable(null);
  self.startMinute = ko.observable(null);
  self.timeZone = null;
  self.units = null;
  self.startDate = ko.observable(null);

  // Invariant: Non-Recurrent Recurrences can only span one day.
  self.endDate = ko.computed(function () {
    return (self.recurrenceInterval() == "never")
      ? moment(self.startDate()).add(1, 'day').format("YYYY-MM-DD")
      : null;
  });

	/**
	* Creates a subscription to the recurrenceInterval observable
	* When changed, this value can have effects on the recurrence collection
	*/
  self.recurrenceInterval.subscribe(function (data) {
    if (data == 'daily') {
      self.recurrence(['0', '1', '2', '3', '4', '5', '6']);
    }
    else if (data == 'never') {
      self.recurrence.removeAll();
      self.recurrenceStart = null;
      self.recurrenceEnd = null;
    }
    else if (data == 'none') {
      self.recurrence.removeAll();
      self.recurrence.push(qcal.availabilitySelectedDay().toString());
    }
  }, null, 'change');



  self.endHour.subscribe(function (newVal) {
    self.recalcDuration();
  }, null, 'change');



  self.endMinute.subscribe(function (newVal) {
    self.recalcDuration();
  }, null, 'change');



  self.startHour.subscribe(function (newVal) {
    self.recalcDuration();
  }, null, 'change');



  self.startMinute.subscribe(function (newVal) {
    self.recalcDuration();
  }, null, 'change');


  self.availOnDay = function (iDayNum) {
    return self.recurrence().indexOf(iDayNum.toString()) > -1;
  };


	/**
	* Determines the height, in pixels, of the time block in the UI
	*
	* @method cssHeight
	* @return {String}
	*/
  self.cssHeight = ko.computed(function () {
    var iLabelHeight = $('#availabilityHourContainer li').outerHeight();		// Height of the hour labels

    return parseInt((self.duration() / 60) * iLabelHeight) + 'px';
  });


	/**
	* Determines the top pixels of the time block in the UI
	*
	* @method cssTop
	* @return {String}
	*/
  self.cssTop = ko.computed(function () {
    var iLabelHeight = $('#availabilityHourContainer li').outerHeight(),		// Height of the hour labels
      iTop = 0;

    iTop = (iLabelHeight * self.startHour()) + parseInt((self.startMinute() / 60) * iLabelHeight);

    return iTop + 'px';
  });


	/**
	* Method converts recurrence back into a bitmask
	*
	* @method dayBitMask
	* @return {Integer}
	*/
  self.dayBitMask = ko.computed(function () {
    var i = 0,
      sDaysOfWeek = '';

    for (i = 0; i < 7; i++) {
      sDaysOfWeek += (self.recurrence().indexOf(i.toString()) > -1) ? '1' : '0';
    }

    return parseInt(sDaysOfWeek, 2);
  });


	/**
	* Determines the start time as a string based on startHour and startMinute
	*
	* @method start
	* @return {String}
	*/
  self.start = ko.computed(function () {
    if (self.startHour() !== null && self.startMinute() != null) {
      return self.startHour() + self.pad(self.startMinute(), 2);
    }

    return null;
  });


	/**
	* Generates a string to show the start/end times for the availability
	*
	* @method startToEndDisplay
	* @return {String}
	*/
  self.startToEndDisplay = ko.computed(function () {
    var mEnd = new moment(),
      mStart = new moment();

    mStart.hours(self.startHour());
    mStart.minutes(self.startMinute());

    mEnd = new moment(mStart);
    mEnd.add(self.duration(), 'minutes');

    return mStart.format('LT') + ' - ' + mEnd.format('LT');

  });


	/**
	* Method to assist determining if the availability occurs on the specified day of the week
	*
	* @method appointmentOccursOnDay
	* @param {Integer} iDayNum Number of the day of the week to check for recurrence
	* @return {Boolean} Returns true if the availability recurs on the specified day of the week
	*/
  self.appointmentOccursOnDay = function (iDayNum) {
    return (self.recurrence.indexOf(iDayNum.toString()) > -1);
  };


	/**
	* Method to convert the XML data representing this DataModel
	* into observed variables above.
	*
	* @method loadData
	* @param {XMLString} data XML String representing this model's data
	* @return {AvailabilityModel} Returns the data model as chainable, for best practice
	*/
  self.loadData = function (data) {
    var aDayBitMask = [],
      aTemp = [],
      durationUnits = null,
      iDuration = 0;

    // Call the superclass method of the same name
    // This loads the XML into the object's data member
    // and converts the data into JSON for easy assignment
    AbstractDataModel.prototype.loadData.call(self, data);

    self.id = parseInt(self.json.id, 0);

    self.deleted = (self.json.deleted && self.json.deleted == 'true');

    // Set the start time of the availabilty
    self.startHour(parseInt(self.json.startHour, 0));
    self.startMinute(parseInt(self.json.startMinute, 0));

    // Determine the duration of the availability
    self.units = self.json.duration.units;
    iDuration = parseInt(self.json.duration.duration, 0);

    if (self.units == 'hrs') {
      iDuration *= 60;
      self.units = 'min';
    }


    var mEnd = new moment();
    mEnd.hours(self.startHour());
    mEnd.minutes(self.startMinute() + iDuration);

    self.end = mEnd.format('Hmm');
    self.endHour(mEnd.hours());
    self.endMinute(mEnd.minutes());

    // If the duration is expressed in hours, multiply the duration value by 60 minutes
    if (self.units != 'min') {
      iDuration = iDuration * 60;
    }

    self.duration(iDuration);

    // Set the specified Timezone
    self.timeZone = self.json.timeZone;


    if (self.json.dailyRecurrence) {
      self.recurrenceInterval('daily');
    }
    else if (self.json.weeklyRecurrence) {
      self.recurrenceInterval('weekly');
    }
    else if (self.json.monthlyRecurrence) {
      self.recurrenceInterval('monthly');
    }
    else if (self.json.yearlyRecurrence) {
      self.recurrenceInterval('yearly');
    }
    else if (self.json.nonRecurrentRecurrence) {
      self.recurrenceInterval('never');
    }


    if (self.json.dailyRecurrence) {
      self.recurrence(['0', '1', '2', '3', '4', '5', '6']);
    }
    else if (self.json.weeklyRecurrence) {
      
      if (self.json.weeklyRecurrence.start) {
        self.recurrenceStart = self.json.weeklyRecurrence.start;
      }

      if (self.json.weeklyRecurrence.end) {
        self.recurrenceEnd = self.json.weeklyRecurrence.end;
      }

      // Determine the weekly recurrence
      // Parse the days bitmask into an number string, 7 characters long, and then split it to an array
      self.daysOfWeek = parseInt(self.json.weeklyRecurrence.days, 0);

      // aDayBitmask represents the days of the week like [ 0, 0, 0, 0, 0, 0, 0].
      // If a bit is on (1), the availability occurs (reccurs) on that day.
      // It follows ordinal days. For example, aDayBitMask[0] is Sunday.
      var aDayBitMask = self.pad(self.daysOfWeek.toString(2), 7).split('');
      var recurrenceDays = [];

      for (var ordinalDay = 0; ordinalDay < aDayBitMask.length; ordinalDay++) {
        if (aDayBitMask[ordinalDay] == '1') {
          recurrenceDays.push(ordinalDay.toString());
        }
      }

      self.recurrence(recurrenceDays);
    }

    if (self.json.nonRecurrentRecurrence) {
      var nrr = self.json.nonRecurrentRecurrence;

      if (typeof nrr.start != "string" || !/^\d{4}-\d{2}-\d{2}/.test(nrr.start)) {
        throw new Error("Non-Recurrent Availability [" + self.id + "] must provide StartDate")
      }

      self.startDate(nrr.start.split('T')[0])
    }

    // Return self (AvailabilityModel) to be chainable, for best practice
    return self;
  };


	/**
	* Inspects the start and end times and determines the new duration
	*
	* @method recalcDurationrecalcDuration
	* @return {AvailabilityModel} Returns the data model as chainable, for best practice
	*/
  self.recalcDuration = function () {
    var mStart = new moment(),
      mEnd = new moment(),
      iDiff = 0;

    if (self.duration() != null) {
      mStart.hours(self.startHour());
      mStart.minutes(self.startMinute());

      mEnd.hours(self.endHour());
      mEnd.minutes(self.endMinute());

      iDiff = mEnd.valueOf() - mStart.valueOf();

      if (iDiff > 0) {
        self.duration(iDiff / (1000 * 60));
      }
    }

    // Return self (AvailabilityModel) to be chainable, for best practice
    return self;
  };


	/**
	* Transacts changes in the UI into the recurrence array for this model
	*
	* @method setRecurrence
	* @param {AvailabilityModel} data This AppointmentModel
	* @param {Event} evt Event triggered by UI interaction
	* @return {Boolean} true in order to allow event to bubble
	*/
  self.setRecurrence = function (data, evt) {
    evt.stopPropagation();

    var iDayNum = parseInt($(evt.target).attr('data-dayNum'));

    if (self.recurrence.indexOf(iDayNum.toString()) > -1) {
      self.recurrence.remove(iDayNum.toString());
    }
    else {
      self.recurrence.push(iDayNum.toString());
    }

    qcal.resourceAvailabilityWS.availability.valueHasMutated();
    qcal.selectedAvailability().recurrence.valueHasMutated();

    return false;
  };


  // If the model was initialized with a data parameter,
  // call the loadData method to populate the observed variables.
  if (data) {
    self.loadData(data);
  }

  // Return self (AvailabilityModel) to be chainable, for best practice
  return self;
};

AvailabilityModel.prototype = Object.create(AbstractDataModel.prototype, {});
AvailabilityModel.prototype.constructor = AvailabilityModel;


/**
 * Transforms the recurrence type used in the UI to the Recurrence Interval type
 * accepted by the API
 *
 * @return {string}
 */
AvailabilityModel.prototype.recurrenceType = function () {
  var intervalTypes = {
    'daily': 'daily',
    'weekly': 'weekly',
    'yearly': 'yearly',
    'monthly': 'monthly',
    'never': 'nonRecurrent'
  }

  return intervalTypes[this.recurrenceInterval()]
}

if (typeof exports !== 'undefined') {
  exports.AvailabilityModel = AvailabilityModel;
}

